'use client';

import { Grid2, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { DonateButton } from '@/ui/buttons/DonateButton';
import { KnowMoreButton } from '@/ui/buttons/KnowMoreButton';
import type { CampaignConfig } from '../config.interface';
import { formatNumber } from '@/infrastructure/zustand/utils';

export const CampaignBeneficiaries = ({
	config,
	formatBeneficiariesAsSpanishNumber,
	isAlala,
}: {
	config: CampaignConfig;
	formatBeneficiariesAsSpanishNumber: boolean | undefined;
	isAlala: boolean | undefined;
}) => {
	const { i18n } = useTranslation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const isTablet = useMediaQuery(theme.breakpoints.down('md'));
	const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

	const color = 'black';

	const sxsubtitle = {
		marginTop: '5px',
		fontSize: '17px',
		color,
	};
	const sxtitle = {
		fontSize: '30px',
		color,
		fontWeight: 900,
	};

	const sxdescription = {
		color,
		marginTop: '15px',
		fontSize: '15px',
		fontWeight: 400,
	};

	if (
		!config.campaign.beneficiaries ||
		!config.campaign.beneficiaries.direct ||
		!config.campaign.beneficiaries.indirect ||
		config.campaign.beneficiaries.direct <= 0 ||
		config.campaign.beneficiaries.indirect <= 0
	)
		return null;

	return (
		<Grid2 container direction="row" justifyContent="flex-start">
			<Grid2
				container
				sx={
					isAlala && isTablet && !isDesktop && !isMobile
						? {
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								padding: '1rem',
								gap: '1rem',
							}
						: {
								display: 'none',
							}
				}
			>
				<Grid2>
					<DonateButton config={config} isFunded={config.campaign.finished} campaignId={config.campaign.id} />
				</Grid2>
				<Grid2>
					<KnowMoreButton />
				</Grid2>
			</Grid2>
			<Grid2 size={{ xs: 12, sm: 6 }} sx={{ textAlign: 'center' }}>
				<Typography sx={sxtitle}>{formatNumber(i18n.language, config.campaign.beneficiaries.direct)}</Typography>
				<Typography sx={sxsubtitle}>
					<Trans i18nKey="directBeneficiaries" />
				</Typography>
				<Typography sx={sxdescription}>
					<Trans i18nKey="directBeneficiariesDescription" />
				</Typography>
			</Grid2>
			<Grid2 size={{ xs: 12, sm: 6 }} sx={{ textAlign: 'center' }}>
				<Typography sx={sxtitle}>
					{formatNumber(
						formatBeneficiariesAsSpanishNumber ? 'ca-ES' : i18n.language,
						config.campaign.beneficiaries.indirect,
					)}
				</Typography>
				<Typography sx={sxsubtitle}>
					<Trans i18nKey="indirectBeneficiaries" />
				</Typography>
				<Typography sx={sxdescription}>
					<Trans i18nKey="indirectBeneficiariesDescription" />
				</Typography>
			</Grid2>
		</Grid2>
	);
};
